import * as React from "react";

export class TeamScore extends React.Component<{ score: string, modifier?: string }, {}> {

    render() {
        return (
            <div className={`${this.props.modifier ? this.props.modifier : ""}`}>{this.props.score}</div>
        )
    }
}